import React from 'react';
import { TabProps } from '../../../../SourceModal.types';
import { getSourceDisplayName } from '../../../../SourceModal.config';
import BaseOverview from './BaseOverview';

const CRMOverview: React.FC<TabProps> = ({ source, language }) => {
    const sourceCode = source?.source_type?.code;
    const displayName = getSourceDisplayName(sourceCode, source?.source_type?.name);

    return (
        <BaseOverview 
            language={language} 
            title={displayName}
        >
            <div>
                <p>
                    Connect your {displayName} account to SignalSight to automatically 
                    sync lead and customer data. This integration enables real-time 
                    event transmission to your advertising platforms, helping you 
                    optimize campaigns based on actual conversions and customer actions.
                </p>
                <div className="mt-3">
                    <h3 className="mb-2">Integration Features:</h3>
                    <ul style={{ paddingLeft: '1.5rem', listStyleType: 'disc' }}>
                        <li>Automatic lead status sync</li>
                        <li>Custom field mapping</li>
                        <li>Real-time event triggers</li>
                        <li>Historical data import</li>
                    </ul>
                </div>
            </div>
        </BaseOverview>
    );
};

export default CRMOverview;



